/* eslint-disable react/prop-types */
import React from 'react';
import './Card.scss';

const Card = ({
  title,
  description,
  additionalDescription,
  imageSrc,
  illuClass,
  imageSrcAlt,
  primaryButtonText,
  primaryButtonAction,
  primaryButtonDisable = false,
  secondaryButtonText,
  secondaryButtonAction,
  customClass = ''
}) => (
  <div className={`card ${customClass}`}>
    {imageSrc && <div className="left-card"><img alt={imageSrcAlt} className="leftImage" src={imageSrc} /></div>}
    <div className="right-card">
      {illuClass&&<span className={illuClass} aria-hidden="false"></span>}
      <h3 className="cardheader">{title}</h3>
      {description && <div className="carddescription"> {description} </div>}
      {additionalDescription && <div className="carddescription cardadditionaldescription"> {additionalDescription} </div>}
      <div className="half-card">
        {primaryButtonText && <button className="primaryButton" onClick={primaryButtonAction} disabled={primaryButtonDisable}>
          {primaryButtonText}
        </button>}
        {secondaryButtonText && <button className="secondaryButton" onClick={secondaryButtonAction}>
          {secondaryButtonText}
        </button>}
      </div>
    </div>
  </div>
);

export default Card;